// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"Assets_imgWrapper__2CwWi","pagination":"Assets_pagination__2UOsh"};